export const CommonEnvironment = {
  // authentication
  subUrlLogin: '/auth/login',
  subUrlogout: '/auth/logout',
  subUrlAcceptConditions: '/api/user/acceptTermsOfUse',
  subUrlrefreshToken: '/auth/token/refresh',
  subUrlChangePassword: '/api/user/changePassword',
  subUrlUserInfo: '/api/user/info/self',
  subUrlCheckRecovery: '/api/user/sendEmailPasswordRecovery',
  subUrlRecovery: '/api/user/passwordRecovery',

  subUrlCombosCommon: '/api/product/combosCommon',

  //User combos
  subUrlUserById: '/api/request/combos/getUserById',

  subUrlDivision: '/api/request/combos/division',
  subUrlOffices: '/api/request/combos/offices',

  subURlChains: '/api/request/combos/chains',
  subUrlPrescribers: '/api/request/combos/prescribers',
  subUrlEstablishments: '/api/request/combos/establishments',
  subUrlVendors: '/api/request/combos/vendors',
  subUrlChainByDivision: '/api/request/combos/getAllChainsByDivision',

  //product requests
  subUrlExpirationDays: '/api/product/deadline',
  subUrlModalityPayment: '/api/product/modalityPayment',
  subUrlFormPayment: '/api/product/buy/formPayment',
  subUrlProductLine: '/api/product/buy/productLine',
  subUrlCommercialProduct: '/api/product/buy/commercialProduct',
  subUrlCommercialProductForCombos: '/api/product/buy/commercialProductForCombos',
  subUrlProduct: '/api/product/buy/product',
  subUrlTarifas: '/api/product/tariffs',
  subUrlSimulationFinancing: '/api/request/calculator/financing',
  subUrlStateRequests: '/api/product/panel/status',
  subUrlEmploymentSituation: '/api/product/combos/professionByEmplymentSituation',
  subUrlSectorBusiness: '/api/product/combos/sectorBusinessByProfession',
  subUrlCnae: '/api/product/combos/cnae',
  subUrlPrescriberData: '/api/request/get/prescriberData',

  //save request consumption
  subUrlSaveConsume: '/api/consumo/save',
  //send request consumption
  subUrlSendConsume: '/api/consumo/send',

  // save request
  subUrlSaveCard: '/api/card/save',
  //autos requests
  subUrlTypeVehicle: '/api/product/autos/typeVehicle',
  subUrlBrandByYear: '/api/product/autos/brandByYear',
  subUrlModelByBrandAndYear: '/api/product/autos/modelByBrandAndYear',
  subURLVersion: '/api/product/autos/version',
  subURLFuelType: '/api/product/autos/typeFuel',

  //calculator
  subUrlCalculatorAutos: '/api/request/calculator/financing',

  // save request
  subUrlSaveAutos: '/api/autos/save',

  //save rack
  subUrlSaveRackAutos: '/api/autos/save/rack',

  // send request
  subUrlSendCard: '/api/card/send',
  subUrlSendAutos: '/api/autos/send',

  // save/send request mango
  subUrlSaveCardMg: '/api/card/mango/purchase/save',
  subUrlSaveCardMgNoShop: '/api/card/mango/save',
  subUrlSendCardMg: '/api/card/mango/purchase/send',
  subUrlSendCardMgNoShop: '/api/card/mango/send',
  subUrlgetTestCard: '/api/card/saveBpMgWithAssurance',

  // print request
  subUrlPrintAutos: '/api/autos/preparePrint',
  subUrlPrintBP: '/api/card/print/BP',
  subUrlPrintConsumptionPreparePrint: '/api/consumo/preparePrint',
  subUrlPrintConsumption: '/api/consumo/print',
  subUrlPrintMGShopping: '/api/card/print/MG/withPurchase',
  subUrlPrintMGNoShopping: '/api/card/print/MG/withoutPurchase',

  // print authorization
  subUrlPrintAuthorization: '/api/request/print/authorization',

  // print contract
  subUrlPrintContract: '/api/signature/manage/print',

  // historic

  subUrlHistoric: '/api/request/panel/operations/details/historic',

  //session expired
  sessionTimeout: 4 * 60,
  windowSesionTimeout: 60,

  key: 'gjeINgDkeKDx6dZMB7JZ',

  // params mode token
  modeToken: 'COOKIE_TOKEN', //'TOKEN_TIMER'

  //panel request
  subUrlOperations: '/api/request/panel/main/operations',
  subUrlOperationsPagination: '/api/request/panel/main/operations/pagination',
  subUrlDocumentation: '/api/request/panel/operations/details/documentation',

  subUrlAllOperations: '/api/request/panel/all/operations',
  subUrlAllOperationsPagination: '/api/request/panel/all/operations/pagination',

  subUrlAllOperationsFind: '/api/request/panel/main/operations/find',

  //panel get details request
  subUrlDetailRequestConsumo: '/api/consumo/get',
  subUrlDetailRequestCard: '/api/card/get',
  subUrlDetailRequestMangoNS: '/api/card/mango/get',
  subUrlDetailRequestMango: '/api/card/mango/purchase/get',
  subUrlDetailRequestAutos: '/api/autos/get',

  // HOME
  subUrlLatestRequestsHome: '/api/request/get/operations/total',

  // INE
  subUrlINE: '/api/ine/manage/pending',
  subUrlSmsINE: '/api/ine/manage/sendsms',

  // SIGNATURE
  subUrlParticipantsSignature: '/api/signature/get/interveners',
  subUrlGetSaml: '/api/signature/',
  subUrlGetMerchantSaml: '/api/signature/merchant',
  subUrlRejectSignature: '/api/signature/reject/intervener',

  // SIGNATURE ASYNC
  subUrlSendEmailsignatureAsync: '/api/signatureAsync/sendEmail',
  subUrlStartAsyncSignature: '/api/signatureAsync/startAsyncSignature',
  subUrlStartAsyncMerchantSignature: '/api/signatureAsync/startAsyncSignatureMerchant',

  // THIRD PARTY SIGNATURE

  subUrlSAMLThirdPartyFromExternalId: '/api/thirdPartySignature/getSAMLFromExternalId',
  subUrlSetSignFinish: '/api/thirdPartySignature/setSignFinish',

  // CONSENT
  subUrlGetConsent: '/api/consent/get',
  subUrlSendConsent: '/api/consent/send',

  //UPLOAD FILES
  subUrlsendDocs: '/api/request/panel/operations/details/sendDocs',

  //Panel-Control-Combos
  subUrlControlPanelProduct: '/api/dashboard/reports/combos/products',
  subUrlControlPanelArticles: '/api/dashboard/reports/combos/articles',
  subUrlControlPanelOrigins: '/api/dashboard/reports/combos/origins',
  subUrlControlPanelStatus: '/api/dashboard/reports/combos/status',
  subUrlControlPanelExternalCommercialByFilter: '/api/request/combos/getExternalCommercialUserByFilter',
  subUrlControlPanelExternalCommercialByCase: '/api/request/combos/getExternalCommercialUserByFilter',
  subUrlControlPanelDocumentStatus: '/api/request/combos/getStatusDocumentType',

  //Panel-Contol-Consult
  subUrlControlPanelAgents: '/api/dashboard/reports/inv/agents',
  subUrlControlPanelInvestProduct: '/api/dashboard/reports/inv/products',
  subUrlControlPanelAgentStatistics: '/api/dashboard/reports/inv/agentStats',
  subUrlControlPanelInvestments: '/api/dashboard/reports/inv/generalInvestment',
  subUrlControlPanelValidationOperations: '/api/dashboard/reports/inv/validationOperationsReport',
  subUrlControlPanelActionPlan: '/api/dashboard/reports/inv/agentActionPlanReport',
  subUrlControlPanelOperationDetail: '/api/dashboard/reports/inv/reqOpsDetails',
  subUrlControlPenaltyDetailReport: '/api/dashboard/reports/inv/incentiveDetailsAgents',

  // PROFILE USERS
  subUrlAttributions: '/api/attributions/types',
  subUrlUpdateAttributions: '/api/attributions/modify',
  subUrlCreateProfile: '/api/profile/create',
  subUrlUpdateProfile: '/api/profile/modify',
  subUrlGetProfile: '/api/profile/getProfile',
  subUrlGetProfiles: '/api/profile/getProfiles',
  subUrlDeleteProfile: '/api/profile/delete',

  //TPV
  subUrlTPVPurchase: '/api/request/tpv/buy',
  subUrlTPVPrint: '/api/request/tpv/printBoleta',
  subUrlTPVTariffs: '/api/request/tpv/getTariffs',
  subUrlTPVQuery: '/api/request/tpv/getList',
  subUrlTPVQueryPrint: '/api/request/tpv/printList',
  subUrlTPVQueryPrintBoleta: '/api/request/tpv/queries/printBoleta',
  subUrlTPVRefunds: '/api/request/tpv/returnPurchase',
  subUrlTPVPurchaseDescription: '/api/request/tpv/getPurchaseDescription',

  //search operations
  subUrlSearchOperation: '/api/operations/get',

  //user administration
  subUrlSetOtherPassword: '/api/passwords/setPassword',
  subUrlSetOwnPassword: '/api/passwords/setOwnPassword',

  //WHITE LIST
  subUrlGetEntities: '/api/whitelist/getEntities',
  subUrlGetWhiteList: '/api/whitelist/getWhitelists',
  subUrlDeleteWhileList: '/api/whitelist/deleteWhitelist',
  subUrlGetWithoutWhiteList: '/api/whitelist/getUsersWithoutWhiteList',
  subUrlCreateWhiteList: '/api/whitelist/createWhitelist',

  //brand maintenance
  subUrlBrandMaintenance: '/api/brandMaintenance/createBrandMaintenance',

  //Reports
  subUrlReportsECommerce: '/api/report/ecommerce/get',
  subUrlReportsECommerceDetail: '/api/report/ecommerce/detail/get',
  subUrlReportsECommerceDetailTPV: '/api/report/ecommerce/detailTPV/get',
  subUrlPasswordPolicy: '/api/passwords/getPolicies',

  //ADMIN REPORT
  subUrlTypeBsReportAdministrator: '/api/report/administrator/combo/profileByTypeBS',
  subUrlCombosReportAdministrator: '/api/report/administrator/combos',
  subUrlResultsAdminReport: '/api/report/administrator/get',

  // REPORT SIGNATURE
  subUrlCombosReportSignature: '/api/report/digitalSignature/combos',
  subUrlResultsSignatureReport: '/api/report/digitalSignature/get',

  //users
  subUrlSearchUsers: '/api/users/findUsersByFilter',
  subUrlGetUserTree: '/api/users/getUserTreeByUser',

  //ACTIVITY MACROS
  subUrlActivityStatus: '/api/monitoring/reports/getStatus',
  subUrlActivityMacros: '/api/monitoring/reports/get',
  subUrlActivityMacrosExcel: '/api/monitoring/reports/get/', //Diferente para que el loader no salte cuando cargue la exportación de excel sino un popup
  subUrlCancelSignatureContract: '/api/report/digitalSignature/cancelSignatureContract',
  subUrlCancelSignatureINE: '/api/report/digitalSignature/cancelSignatureINE',
  subUrlUpdateStates: '/api/report/digitalSignature/updateStates',
  subUrlGetCertificateSignature: '/api/report/digitalSignature/getCertificate', // NO SE USA YA
  subUrlPrintCertificateSignature: '/api/report/digitalSignature/printCertificate',
  subUrlGetMonthlyReportConsumption: '/api/monitoring/reports/getRequestsConsumerMonth',
  subUrlGetMonthlyReportAutos: '/api/monitoring/reports/getRequestsAutoMonth',

  //CREATE USERS
  subUrlGetExternalCommercial: '/api/user/getExternalCommercial',
  subUrlGetDivisions: '/api/user/getDivisions',
  subUrlGetProfilesUsers: '/api/user/getProfiles',
  subUrlgetSearchUsers: '/api/user/getUsersByFilter',
  subUrlGetBrands: '/api/user/getBrands',
  subUrlGetUserType: '/api/user/getUserType',
  subUrlGetDetailUser: '/api/user/getDetailUser',
  subUrlGetAttributionsUser: '/api/user/getAttributionsByProfile',
  subUrlGetUserTreeByUser: '/api/user/getUserTreeByUser',
  subUrlGetPasswordWS: '/api/passwords/getPasswordWS',
  subUrlCreateUser: '/api/user/create',
  subUrlVendorByFilter: '/api/user/getVendorByFilter',
  subUrlDeleteUser: '/api/user/delete',
  subUrlModifyUser: '/api/user/modify',
  subUrlImpersonatedUserByFilter: '/api/user/getImpersonatedUserByFilter',
  subUrlOfficesByDivision: '/api/request/combos/getOfficesByDivision',
  subUrlChainsWithoutMacrouserByDivision: '/api/user/getChainsWithoutMacroUserByDivision',
  subUrlChainsByMacroUser: '/api/request/combos/getChainsByMacroUser',
  subUrlOfficesByMacroUser: '/api/request/combos/getOfficesByMacroUser',
  subUrlGetProfilesByUserType: '/api/user/getProfilesByUserType',

  //DETAIL USER
  subUrlGetUserDetailById: '/api/users/getUserDetailById',
  subUrlGetUserDetailByUserName: '/api/users/getUserDetailByUserName',
  subUrlHasUsersWithPaymentCertified: '/api/request/combos/hasUsersWithCertifiedPayments',
  subUrlGetUsersWithPaymentCertified: '/api/request/combos/getUsersWithCertifiedPayments',

  //TARIFF SHEET
  subURLCombosSectorByEstablishment: '/api/product/combos/sectorByEstablishment',
  subURLCombosCommercialProductByFilter: '/api/request/combos/getCommercialProductByFilter',
  subURLCombosTariffByFilter: '/api/request/combos/getTariffsByFilter',
  subUrlTariffSheetTable: '/api/tariff/sheets/tariffSheetTable',
  subUrlTradeDiscount: '/api/tariff/sheets/tradeDiscount',
  subUrlTariffInterestCommercialProduct: '/api/product/combos/productsCustomerInterest',
  subUrlCommercialInterest: '/api/tariff/sheets/tariffSheetTableTarTwo',
  subUrlCiCoCommercialProduct: '/api/product/combos/productsCiCoTariffs',
  // ACTIVITY REPORTS
  subUrlPaymentReports: '/api/monitoring/reports/inf/payment',
  subUrlPaymentReportsPrint: '/api/monitoring/reports/inf/payment/print',
  subUrlgetEstablishmentsByPrescribers: '/api/request/combos/getEstablishmentsByPrescribers',
  subUrlgetPrescribersByChains: '/api/request/combos/getPrescriberByChain',

  //PANEL ACTIVITY
  SubUrlActivityPanel: '/api/request/panel/activity',

  //NOTIFICATIONS
  SubUrlNotifications: '/api/notifications/mandatories',
  SubUrlNotificationsActives: '/api/notifications/actives',
  SubUrlNotificationsJasper: '/api/notifications/printJasper',
  SubUrlNotificationsCounter: '/api/notifications/increaseCounter',

  //OPERATION TRACES
  subUrlOperationTraces: '/api/request/panel/operationTraces',

  //TRAINING
  subUrlTrainingPillTutorials: '/api/request/formation/pills/tutorial',
  subUrlTrainingPillFeatured: '/api/request/formation/pills/news',
  subUrlTrainingPillCategories: '/api/request/formation/pills/tutorial/categories',
  subUrlTrainingPillDocuments: '/api/request/formation/pills/documents',
  // BALANCE IC
  subUrlRequestBalanceIC: '/api/request/balancing/financing',
  subUrlSendIC: '/api/ic/send',
  subUrlResendLink: '/api/mailRequest/resend',
  //PING
  subUrlcheckStatus: '/api/ping/checkStatus',
  //   URL_BASE_REQUEST +  subUrlOperationTraces
  //  'http://localhost:4200/request' + '/api/request/panel/operationTraces'

  //URL TECHNICAL ADMIN
  //dashboard
  subUrlDashboard: '/api/alertRule/dashboard',
  //oracleNetException
  subUrlOracleNetException: '/api/alertRule/switch/oracleNetException',
  //changeAlertWarningStatus
  subUrlChangeAlertWarningStatus: '/api/alertRule/switch/changeAlertWarningStatus',

  //Jobs
  subUrlGetJobs: '/api/crashreport/job/get/all',
  subUrlChangeJobWarningStatus: '/api/crashreport/job/update/status',
  //GEOCODE CTI
  subUrlListPopulation: '/ESP/ListarPoblacion',
  subUrlListPopulationCodPostal: '/ESP/ListarPobCodPostal',

  subUrlListMunicipio: '/ESP/ListarMunicipio',
  subUrlListTypesVia: '/ESP/ListarTiposVia',
  subUrlListVia: '/ESP/ListarVia',

  subUrlNormalizarDomicilio: '/ESP/NormalizarDomicilio',
  subUrlNormalizarRestoDomicilio: '/ESP/NormalizarRestoDomicilio',
  subUrlValidarEmail: '/PF/ValidarEmail',
  subUrlValidarTelefono: '/ESP/ValidarTelefono',
  subUrlNormalizarNombre: '/ESP/NormalizarNombre',

  subUrlNormalizarPoblacion: '/ESP/NormalizarPoblacion',
  subUrlNormalizarVia: '/ESP/NormalizarVia',
  //VIDEO SELFING

  subUrlVideoSelfingDigitalID: '/api/videoSelfing/digitalId',
  subUrlPendingVideoSelfing: '/api/videoselfing/manage/pending',
  subUrlSendSMSVideoSelfing: '/api/videoselfing/manage/sendsms',
  subUrlObtenerTokenVideoselfing: '/api/videoselfing/onfido/getToken',
  subUrlGetLanding: '/api/videoselfing/onfido/getLanding',
  subUrlCrearCheckVideoselfing: '/api/videoselfing/onfido/createCheck',
  subUrlCrearCheckConsentimientosVideoselfing: '/api/videoselfing/acceptConsents',
  subUrlHistoricalStatusOnfido: '/api/videoselfing/onfido/updateLandingStatus',

  //Certification Payment
  subUrlPaymentCertRegister: '/api/certificatePayment/sendRequest',
  subUrlPaymentCertReport: '/api/certificatePayment/getRecord',

  // auth by num sol
  subUrlAuthByNumSol: '/api/request/panel/getAuthByNumsol',
};
